module.exports = __webpack_public_path__ + "img/tripartite.3216f428.png";